import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, name, className, ...props }) => {
  // 1. If a component is passed directly (e.g., <SafeIcon icon={FiUsers} />)
  if (IconComponent) {
    return <IconComponent className={className} {...props} />;
  }

  // 2. If a name string is passed (e.g., <SafeIcon name="Users" />)
  if (name) {
    const ResolvedIcon = FiIcons[name.startsWith('Fi') ? name : `Fi${name}`];
    if (ResolvedIcon) {
      return <ResolvedIcon className={className} {...props} />;
    }
  }

  // 3. Fallback to alert icon
  return <FiAlertTriangle className={className} {...props} />;
};

export default SafeIcon;